import app from '../../appInstance';
import registerJunctionAp from '@junction-ap/vue-register';
import registerLogbook from '@logbook/vue-register';
import registerTicketManagerAp from '@ticket-manager-ap/vue-register';
import registerSoundStackTicketing from '@soundstack-ticketing/vue-register';
import registerAdminPanelStartHub from '@adminpanel-start-hub/vue-register';
import registerAdminPanelVueKit from '@adminpanel-vue-kit/vue-register';
import registerUserNotificationsAp from '@user-notifications-ap/vue-register';

const registrars = require.context(
    '../../../../Fabrico/SoundStack',
    true,
    /-AP\/resources\/js\/vue-register\.js$/,
);

registrars.keys().forEach((key) => {
    const register = registrars(key).default;
    if (typeof register === 'function') {
        register(app);
    }
});

// Packages outside Fabrico/SoundStack — register explicitly.
registerJunctionAp(app);
registerLogbook(app);
registerTicketManagerAp(app);
registerSoundStackTicketing(app);
registerAdminPanelStartHub(app);
registerAdminPanelVueKit(app);
registerUserNotificationsAp(app);
